import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-issue-wise-report-advt-detail-business',
  templateUrl: './issue-wise-report-advt-detail-business.component.html',
  styleUrl: './issue-wise-report-advt-detail-business.component.scss'
})
export class IssueWiseReportAdvtDetailBusinessComponent implements OnInit {

  allCategories: any[] = [];
  isLoading = false;

  // Static data object with all fields
  staticData = {
    varshikKarar: { niyojan: 0, uddishth: 0, purtata: 0, next_year: 0, used_till_date: 0, total_business: 0 },
    prasangikJahirati: { niyojan: 0, uddishth: 0, purtata: 0, next_year: 0, used_till_date: 0, total_business: 0 },
    niyimitVisheshank: { niyojan: 0, uddishth: 0, purtata: 0, next_year: 0, used_till_date: 0, total_business: 0 },
    sang: { niyojan: 0, uddishth: 0, purtata: 0, next_year: 0, used_till_date: 0, total_business: 0 },
    visheshPurvani: { niyojan: 0, uddishth: 0, purtata: 0, next_year: 0, used_till_date: 0, total_business: 0 },
    dengi: { niyojan: 0, uddishth: 0, purtata: 0, next_year: 0, used_till_date: 0, total_business: 0 },
    karyakramMadhyam: { niyojan: 0, uddishth: 0, purtata: 0, next_year: 0, used_till_date: 0, total_business: 0 }
  };

  // Header Variables
  givenTarget: number = 0;
  niyojanTotal: number = 0;
  purtataTotal: number = 0;
  remainingAmount: number = 0;
  achievementPercent: number = 0;
  remainingPercent: number = 0;

  categoryOrder = ['नियिमत अंक', 'विशेषांक', 'ग्रंथ', 'प्राेग्राम'];

  constructor(
    private dialogRef: MatDialogRef<IssueWiseReportAdvtDetailBusinessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef
  ) { }
  displayYear: string = '';

  ngOnInit(): void {
    // Set the display year from financial year
    this.displayYear = this.formatFinancialYear(this.data.financial_year);

    const payload = {
      start_date: this.data.startDate,
      end_date: this.data.endDate,
      financial_year: this.data.financial_year,
      rep_name: this.data.repname || '',
      off_rep_name: this.data.offRepName || '',
      district: this.data.district,
      taluka: this.data.taluka
    };
    this.loadBusinessReport(payload);
  }


  // Add this new method
  formatFinancialYear(financialYear: string): string {
    if (!financialYear) return '२०२5-२6';

    // Convert English numerals to Marathi numerals
    const marathiNumerals: { [key: string]: string } = {
      '0': '०', '1': '१', '2': '२', '3': '३', '4': '४',
      '5': '५', '6': '६', '7': '७', '8': '८', '9': '९'
    };

    return financialYear.split('').map(char => marathiNumerals[char] || char).join('');
  }


  loadBusinessReport(payload: any): void {
    
  this.isLoading = true;
  this.service.getBusinessDetailReportIssue(payload).subscribe({
   next: (res: any) => {
  console.log('Backend Response:', res);

  // Fix year
  if (res?.financial_year_label) {
    this.displayYear = res.financial_year_label;
  }

  // Fix givenTarget — set BEFORE updateCalculations()
  if (res?.given_target !== undefined && res?.given_target !== null) {
    this.givenTarget = Number(res.given_target);
  }

  if (res?.success && Array.isArray(res.categories)) {
    this.allCategories = this.sortCategories(res.categories.map((cat: any) => ({
      category_name: cat.category_name,
      is_special: cat.is_special || false,
      monthly_data: (cat.monthly_data || []).map((row: any) => ({
        month: row.month || '',
        bill_date: row.bill_date || '',
        niyojan: Number(row.niyojan) || 0,
        uddishth: Number(row.uddishth) || 0,
        purtata: Number(row.purtata) || 0,
        next_year: Number(row.next_year) || 0,
        used_till_date: Number(row.used_till_date) || 0,
        total_business: Number(row.total_business) || 0,
        subCategory: row.subCategory || ''
      }))
    })));

    if (res.prasangik_totals) {
      this.staticData.prasangikJahirati.purtata = Number(res.prasangik_totals.purtata) || 0;
      this.staticData.prasangikJahirati.used_till_date = Number(res.prasangik_totals.used_till_date) || 0;
      this.staticData.prasangikJahirati.total_business = Number(res.prasangik_totals.total_business) || 0;
    }

    // Also set niyamitAnkKarar and niyamitAnkPrasangik from backend if available
    if (res.niyamit_karar_totals) {
      this.bottomData.niyamitAnkKarar.purtata = Number(res.niyamit_karar_totals.purtata) || 0;
      this.bottomData.niyamitAnkKarar.used_till_date = Number(res.niyamit_karar_totals.used_till_date) || 0;
      this.bottomData.niyamitAnkKarar.total_business = Number(res.niyamit_karar_totals.total_business) || 0;
    }

    this.updateCalculations(); // called AFTER givenTarget is set
  }

  this.isLoading = false;
  this.cdr.detectChanges();
}
    });
    
  }
  

  sortCategories(categories: any[]): any[] {
    return categories.sort((a, b) => {
      let indexA = this.categoryOrder.indexOf(a.category_name);
      let indexB = this.categoryOrder.indexOf(b.category_name);
      return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
    });
  }

  calculateCategoryTotal(categoryData: any[], field: string): number {
    if (!categoryData || !Array.isArray(categoryData)) return 0;
    return categoryData.reduce((sum, item) => sum + (Number(item[field]) || 0), 0);
  }
  

  calculateCategoryTotalRemaining(categoryData: any[]): number {
    if (!categoryData || !Array.isArray(categoryData)) return 0;
    return categoryData.reduce((sum, item) => {
      const remaining = (Number(item.uddishth) || 0) - (Number(item.niyojan) || 0);
      return sum + remaining;
    }, 0);
  }

  

  calculateRemaining(row: any): number {
    return (Number(row.uddishth) || 0) - (Number(row.niyojan) || 0);
  }

  calculateStaticTotal(field: string): number {
    return Object.values(this.staticData).reduce((sum, item: any) => sum + (Number(item[field]) || 0), 0);
  }

  calculateStaticRemaining(item: any): number {
    return (Number(item.uddishth) || 0) - (Number(item.niyojan) || 0);
  }

  getCategoryLabel(idx: number): string {
    const labels = ['ब', 'क', 'ड', 'इ'];
    return labels[idx] || (idx + 1).toString();
  }

  getCategoryHeaderColor(idx: number): string {
    const colors = ['#fff9c4', '#c8e6c9', '#ffccbc', '#e1bee7'];
    return colors[idx] || '#f5f5f5';
  }

  getCategoryTotalColor(idx: number): string {
    const colors = ['#fff59d', '#a5d6a7', '#ffab91', '#ce93d8'];
    return colors[idx] || '#eeeeee';
  }

  updateCalculations(): void {
    let totalPurtata = 0;
    let totalNiyojan = 0;
    let totalUddishth = 0;

    // Add static data totals
    totalNiyojan += this.calculateStaticTotal('niyojan');
    totalUddishth += this.calculateStaticTotal('uddishth');
    totalPurtata += this.calculateStaticTotal('purtata');

    // Aggregate totals from all categories and rows
    this.allCategories.forEach(cat => {
      if (cat.monthly_data && Array.isArray(cat.monthly_data)) {
        cat.monthly_data.forEach((row: any) => {
          totalPurtata += Number(row.purtata || 0);
          totalNiyojan += Number(row.niyojan || 0);
          totalUddishth += Number(row.uddishth || 0);
        });
      }
    });

    this.niyojanTotal = totalNiyojan;
    this.purtataTotal = totalPurtata;
    this.remainingAmount = this.givenTarget - this.purtataTotal;

    if (this.givenTarget > 0) {
      this.achievementPercent = Number(((this.purtataTotal / this.givenTarget) * 100).toFixed(2));
      this.remainingPercent = Number(((this.remainingAmount / this.givenTarget) * 100).toFixed(2));
    }
    this.cdr.detectChanges();

    // Add inside updateCalculations() after existing aggregation:
    totalNiyojan += Number(this.bottomData.niyamitAnkKarar.niyojan || 0);
    totalNiyojan += Number(this.bottomData.niyamitAnkPrasangik.niyojan || 0);
    totalPurtata += Number(this.bottomData.niyamitAnkKarar.purtata || 0);
    totalPurtata += Number(this.bottomData.niyamitAnkPrasangik.purtata || 0);
    totalUddishth += Number(this.bottomData.niyamitAnkKarar.uddishth || 0);
    totalUddishth += Number(this.bottomData.niyamitAnkPrasangik.uddishth || 0);
  }

  closeDialog() {
    this.dialogRef.close();
  }


  exportToExcel(): void {
    const table = document.getElementById('business-report-table');
    if (!table) return;

    import('xlsx').then(xlsx => {
      const ws = xlsx.utils.table_to_sheet(table);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, 'व्यवसाय अहवाल');
      xlsx.writeFile(wb, 'Issue_Wise_Business_Report.xlsx');
    });
  }

  // printPageA4Portrait(): void {
  //   const printSection = document.getElementById('print-area');
  //   if (!printSection) return;

  //   const win = window.open('', '', 'width=800,height=1100');
  //   if (!win) return;

  //   win.document.write(`
  //     <html>
  //     <head>
  //       <style>
  //         @page { size: A4 portrait; margin: 8mm; }

  //         /* Enable color printing */
  //         @media print {
  //           * {
  //             -webkit-print-color-adjust: exact !important;
  //             print-color-adjust: exact !important;
  //             color-adjust: exact !important;
  //           }
  //         }

  //         body { font-family: Arial; margin: 0; padding: 0; }
  //         table { 
  //           border-collapse: collapse; 
  //           width: 100%; 
  //         }
  //         th, td {
  //           border: 1px solid #000;
  //           padding: 4px 6px;
  //           font-size: 12px;
  //           text-align: center;
  //           white-space: nowrap;
  //         }
  //         .text-left { text-align: left; padding-left: 8px; }
  //         .bg-light { background-color: #f0f0f0; }
  //         .total-row { font-weight: bold; background-color: #e0e0e0; }
  //         .category-total-row { font-weight: bold; background-color: #ffd700; }
  //         .grand-total-row { font-weight: bold; background-color: #00ffff; }
  //         .section-divider { 
  //           font-weight: bold; 
  //           text-align: center;
  //           background-color: #5f9ea0;
  //           padding: 5px;
  //           color: #000;
  //         }
  //         .special-header-row { background-color: #f5f5f5; }
  //         thead { display: table-header-group; }
  //         tfoot { display: table-footer-group; }
  //       </style>
  //     </head>
  //     <body>
  //       ${printSection.outerHTML}
  //       <script>
  //         setTimeout(() => { window.print(); window.close(); }, 300);
  //       </script>
  //     </body>
  //     </html>
  //   `);

  //   win.document.close();
  // }

  bottomData = {
    niyamitAnkKarar: { niyojan: 0, uddishth: 0, purtata: 0, next_year: 0, used_till_date: 0, total_business: 0 },
    niyamitAnkPrasangik: { niyojan: 0, uddishth: 0, purtata: 0, next_year: 0, used_till_date: 0, total_business: 0 }
  };

  calculateGrandTotal(field: string): number {
    let total = 0;

    // Static rows total
    total += this.calculateStaticTotal(field);

    // All dynamic categories total
    this.allCategories.forEach(cat => {
      total += this.calculateCategoryTotal(cat.monthly_data, field);
    });

    // Bottom rows total
    total += Number(this.bottomData.niyamitAnkKarar[field] || 0);
    total += Number(this.bottomData.niyamitAnkPrasangik[field] || 0);

    return total;
  }

  printPageA4Portrait(): void {
    const printSection = document.getElementById('print-area');
    if (!printSection) return;

    const win = window.open('', '', 'width=800,height=1100');
    if (!win) return;

    win.document.write(`
    <html>
    <head>
      <meta charset="UTF-8">
      <style>
        @page { 
          size: A4 portrait; 
          margin: 10mm 8mm 10mm 8mm; 
        }
        
        /* Enable color printing */
        @media print {
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
        }
        
        body { 
          font-family: Arial, sans-serif; 
          margin: 0; 
          padding: 0; 
          font-size: 10px;
        }
        
        table { 
          border-collapse: collapse; 
          width: 100%; 
          page-break-inside: auto;
        }
        
        tr { 
          page-break-inside: avoid; 
          page-break-after: auto; 
        }
        
        thead { 
          display: table-header-group; 
        }
        
        tfoot { 
          display: table-footer-group; 
        }
        
        th, td {
          border: 1px solid #000;
          padding: 3px 4px;
          font-size: 9px;
          text-align: center;
          white-space: nowrap;
        }
        
        .header-title {
          font-size: 12px;
          font-weight: bold;
          padding: 6px;
        }
        
        .input-header-cell {
          font-size: 10px;
          font-weight: bold;
        }
        
        .user-name {
          font-size: 11px;
          font-weight: bold;
        }
        
        .vertical-header {
          writing-mode: vertical-rl;
          text-orientation: mixed;
          font-weight: bold;
          font-size: 10px;
        }
        
        .text-left { 
          text-align: left; 
          padding-left: 6px; 
        }
        
        .bg-grey { 
          background-color: #f0f0f0; 
        }
        
        .category-total-row { 
          font-weight: bold; 
        }
        
        .section-row {
          font-weight: bold;
          text-align: left;
          padding-left: 8px;
        }
        
        /* Hide input fields borders in print */
        input {
          border: none;
          background: transparent;
          text-align: center;
          width: 100%;
          font-size: 9px;
        }
        
        /* Specific background colors for sections */
        .main-header {
          background-color: #e3f2fd !important;
        }
        
        .sub-header {
          background-color: #fff9c4 !important;
        }
        
        .column-labels {
          background-color: #e1f5fe !important;
          font-weight: bold;
        }
      </style>
    </head>
    <body>
      ${printSection.outerHTML}
      <script>
        setTimeout(() => { window.print(); window.close(); }, 500);
      </script>
    </body>
    </html>
  `);

    win.document.close();
  }


  formatCurrency(value: number | null | undefined): string {

    if (!value || value === 0) return '';
    return value.toString();
  }
}